import { actions } from 'react-redux-form';
import { httpGet, httpPost } from '../../../../../utils/api.utils';
import { getRequestUserSessionData as getUserData } from '../../../../../utils/helpers.utils';
import { getAddresses, getUserLocation } from '../../order-request.functions';
import {
    //model
    wirelessReplaceSimModel
    //action
    , setUserLocation
    , setSimOptions
    , setCountryOptions
    , setAddressOptions
    , setSubscriptionDetails
    , setShowOtherAddress
    , setFormSubmitted
} from './../../../../../constants/model-reducers/external/request/wireless-request/wireless-replace-sim.settings';

export const repalceSimModelAInitialState = wirelessReplaceSimModel;

const defaultState = () => ({
    userLocation: {}
    , simOptions: []
    , countryOptions: []
    , addressOptions: []
    , subscription: {}
    , showOtherAddress: false
    , formSubmitted: false
});

const initialState = defaultState();

export const wirelessReplaceSimActions = {

    onReplaceSimFormLoad: () => (dispatch, state) => {
        const { requestTypeId } = state().createRequest;
        getUserLocation(dispatch, setUserLocation, requestTypeId);
        getCountries(dispatch);
        getSimTypes(dispatch);
    }
    , setRequestorAddress: () => (dispatch, state) => {

        const { showOtherAddress, userLocation } = state().wirelessReplaceSimRequest;


        getAddresses(dispatch, setAddressOptions, userLocation.CountryCode, showOtherAddress);

        dispatch(actions.change('wirelessReplaceSimFormA.country', userLocation.CountryName));
        dispatch(actions.change('wirelessReplaceSimFormA.countryCode', userLocation.CountryCode));
        dispatch(actions.change('wirelessReplaceSimFormA.deliveryAddress', userLocation.DeliveryAddress));
        dispatch(actions.change('wirelessReplaceSimFormA.deliveryAddressId', userLocation.LocationId.toString()));
        dispatch(actions.change('wirelessReplaceSimFormA.otherLocationAddress', ''));

    }
    , onSubscriptionSelect: (value, propsName, objects, index) => (dispatch, state) => {

        const { wirelessReplaceSimFormA } = state().form;

        if (value === '') {
            resetWirelessReplaceSimModel(dispatch);
            dispatch({ type: setSubscriptionDetails, data: {} });
        } else {
            var obj=null              
            if(objects !== null && objects !== undefined) {
                if(index !== -1 && index !== undefined && index !== null) {
                    obj=objects[index]
                }
                else if(objects.length === 1) {
                    obj=objects.find(o => o[propsName] === value);
                } 
            }
            if (obj != null && obj.CircuitId != wirelessReplaceSimFormA.circuitId) {
                resetWirelessReplaceSimModel(dispatch);
                dispatch(actions.change('wirelessReplaceSimFormA.circuitCode', value));
                dispatch(actions.change('wirelessReplaceSimFormA.circuitId', obj.CircuitId));
                dispatch({ type: setSubscriptionDetails, data: obj });
            }
        }
    }

    , onAddressSelect: (model, value) => async (dispatch, state) => {

        const { addressOptions } = state().wirelessReplaceSimRequest;

        dispatch(actions.change(model, value));

        const deliveryAddress = addressOptions.length > 0 ? addressOptions.find(r => r.Key == value).Value : '';
        dispatch(actions.change('wirelessReplaceSimFormA.deliveryAddress', deliveryAddress));
        dispatch(actions.change('wirelessReplaceSimFormA.otherLocationAddress', ''));

    }

    , onCountrySelect: (model, value) => async (dispatch, state) => {

        const { countryOptions, showOtherAddress } = state().wirelessReplaceSimRequest;

        dispatch(actions.change(model, value));

        let country = countryOptions.find(o => o['Key'] === value).Value;
        dispatch(actions.change('wirelessReplaceSimFormA.country', country));
        dispatch(actions.change('wirelessReplaceSimFormA.deliveryAddressId', ''));
        dispatch(actions.change('wirelessReplaceSimFormA.deliveryAddress', ''));

        getAddresses(dispatch, setAddressOptions, value, showOtherAddress);
    }
    , submitRequest: () => async (dispatch, state) => {

        const { wirelessReplaceSimFormA } = state().form;
        const { requestTypeId, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const { subscription } = state().wirelessReplaceSimRequest;

        let userData = getUserData();

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
        }

        var data = {
            ChangeRequestModel: {
                ...userData
                , CircuitId: wirelessReplaceSimFormA.circuitId
                , VendorDetailId: subscription.VendorDetailId
                , AdditionalInformation: wirelessReplaceSimFormA.additionalInformation
                , BillingLocationAddressId: wirelessReplaceSimFormA.deliveryAddressId
                , RequestTypeId: requestTypeId
                , OtherLocationAddress: wirelessReplaceSimFormA.otherLocationAddress
            }
            , NewSimTypeId: wirelessReplaceSimFormA.simTypeId
            , CountryCode: wirelessReplaceSimFormA.circuitCode
            , DeliveryAddressID: wirelessReplaceSimFormA.deliveryAddressId
        };

        dispatch({ type: setFormSubmitted, data: true });
        var res = await httpPost('external/replaceSim/submitReplaceSim', data);

        if (!(res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }

        return res;

    }
    , resetWirelessReplaceSimForm: () => (dispatch) => {
        resetWirelessReplaceSimModel(dispatch);
    }
}

function resetWirelessReplaceSimModel(dispatch) {
    dispatch(actions.reset('wirelessReplaceSimFormA'));
    dispatch({ type: setAddressOptions, data: [] });
    dispatch({ type: setFormSubmitted, data: false });
}

async function getCountries(dispatch) {
    var res = await httpPost('external/replaceSim/getCountries');

    if (res != null && res.length > 0) {
        dispatch({ type: setCountryOptions, data: res });
    } else {
        dispatch({ type: setCountryOptions, data: [] });
    }
}

async function getSimTypes(dispatch) {
    var res = await httpPost('external/replaceSim/getSimType');
    if (res != null && res.length > 0) {
        dispatch({ type: setSimOptions, data: res });
    } else {
        dispatch({ type: setSimOptions, data: [] });
    }
}


export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setUserLocation:
            return {
                ...state,
                userLocation: action.data
            };
        case setCountryOptions:
            return {
                ...state
                , countryOptions: action.data
            };
        case setSimOptions:
            return {
                ...state
                , simOptions: action.data
            };
        case setAddressOptions:
            return {
                ...state
                , addressOptions: action.data
            };
        case setSubscriptionDetails:
            return {
                ...state
                , subscription: { ...action.data }
            };
        case setShowOtherAddress:
            return {
                ...state,
                showOtherAddress: action.data
            };
        case setFormSubmitted:
            return {
                ...state
                , formSubmitted: action.data
            };

        default: return state;
    }
}